const quickTags = ["中文字幕", "国语版", "中文配音", "字幕在线", "中字", "普通话"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20warm%20crimson%20and%20amber%20gradient%20texture%20with%20soft%20bokeh%20light%20streaks%2C%20cinematic%20moody%20atmosphere%2C%20rich%20deep%20tones%2C%20subtle%20film%20grain%2C%20elegant%20dramatic%20background&width=1920&height=1080&seq=shaozi-hero-bg-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/68 to-foreground-950/88"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-[1200px] flex-col justify-center px-4 py-24 md:min-h-[640px] md:px-6 md:py-28">
        <div className="grid items-center gap-12 lg:grid-cols-[1.35fr_0.9fr]">
          <div className="animate-fadeUp">
            <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 font-label text-xs tracking-[0.2em] text-background-100">
              <i className="ri-price-tag-3-line" aria-hidden="true"></i>
              字幕 · 配音 · 版本信息索引
            </p>
            <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
              嫂子的诱惑
              <span className="mt-2 block text-primary-300">中文字幕与国语版信息一站查</span>
            </h1>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              本页汇总与《嫂子的诱惑》相关的字幕与语言版本线索：中文字幕、国语版、中文配音、字幕在线、中字与普通话。
              你可以按对白语言、字幕形式与音轨类型，快速判断哪一种版本更适合自己的观看习惯。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#overview"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-compass-3-line" aria-hidden="true"></i>
                查看版本一览
              </a>
              <a
                href="#filter"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/12"
              >
                <i className="ri-filter-3-line" aria-hidden="true"></i>
                按标签速查
              </a>
            </div>

            <ul className="mt-8 flex flex-wrap gap-2">
              {quickTags.map((tag) => (
                <li
                  key={tag}
                  className="rounded-full border border-background-50/20 bg-background-50/8 px-3 py-1 font-label text-xs text-background-200"
                >
                  {tag}
                </li>
              ))}
            </ul>
          </div>

          <div className="animate-fadeUp-slow">
            <div className="relative mx-auto w-full max-w-[300px] lg:max-w-[330px]">
              <div className="absolute -inset-3 rounded-lg border border-accent-300/30 bg-accent-500/10"></div>
              <div className="relative overflow-hidden rounded-lg border border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%20with%20warm%20crimson%20and%20amber%20tones%2C%20abstract%20silhouette%20of%20two%20figures%20in%20soft%20light%2C%20elegant%20minimal%20composition%2C%20moody%20dramatic%20atmosphere%2C%20artistic%20textured%20background&width=800&height=1120&seq=shaozi-cover-01&orientation=portrait"
                  alt="《嫂子的诱惑》字幕与配音版本封面示意图"
                  className="h-[420px] w-full object-cover object-top md:h-[470px]"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/90 to-transparent p-4 pt-12">
                  <p className="font-heading text-base font-semibold text-background-50">字幕与语言版本</p>
                  <p className="mt-1 font-label text-xs text-background-200">中文字幕 · 国语配音 · 字幕在线</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}